import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Consult = () => {
  return (
    <Box>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Online Consultation
        </Typography>
        <Typography variant="body1">
          Online consultation services coming soon...
        </Typography>
      </Container>
    </Box>
  );
};

export default Consult;
